<template>
    <div class="mead-app-sidebar-item-popover">
        <div class="te-fat-section" :class="[uiShowChildren ? 'sm-b-m' : '']">{{ uiTitle }}</div>
        <nav v-if="uiShowChildren" :aria-label="uiTitle">
            <AppSidebarItem v-for="child in item.children"
                :key="child.uid"
                :item="child"
                @select="onSelectChild"
                @upsell="onUpsellChild" />
        </nav>
    </div>
</template>

<script>
import AppSidebarItem from './AppSidebarItem.vue';

export default {
    name: 'mead-app-sidebar-item-popover',
    components: {AppSidebarItem},
    props: {
        /**
         * The rail `MeadCommon.AppSidebarItem` being hovered. Its label is the popover title.
         */
        item: {type: Object, required: true},
        /**
         * Lists the item's children under the title. The sidebar turns this off while the
         * sub-panel already shows them.
         */
        showChildren: {type: Boolean, default: true},
        /**
         * Called with the chosen child item. Popovers are rendered by the global popover
         * container, outside the sidebar, so callbacks replace events here.
         */
        onSelect: {type: Function, default: () => {}},
        /**
         * Called with a chosen child item that is flagged as `upsell`.
         */
        onUpsell: {type: Function, default: () => {}},
    },
    methods: {
        onSelectChild: function (child) {
            MeadCommon.PopoverService.close();
            this.onSelect(child);
        },
        onUpsellChild: function (child) {
            MeadCommon.PopoverService.close();
            this.onUpsell(child);
        },
    },
    computed: {
        uiShowChildren: function () {
            return this.showChildren && !this.item.upsell && this.item.hasChildren;
        },
        uiTitle: function () {
            return MeadCommon.I18N.go(this.item.label);
        },
    },
};
</script>

<style lang="scss" scoped>
.mead-app-sidebar-item-popover {
    min-width: 20rem;
}
</style>
